<template>
  <div class="viewurl-detail-table">
    <h2>{{ $t('jgjk.s36') }}</h2>
    <div class="viewurl-detail-table">
      <div class="tablebox">
        <el-table :row-class-name="tableRowClassName" v-loading="tableloading" ref="multipleTable" :data="tabledata" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="InsertDate" :label="$t('dsfx.t6')" width="150"></el-table-column>
          <el-table-column prop="Seller" :label="$t('dsfx.t57')"></el-table-column>
          <el-table-column prop="CurrentPrice" :label="$t('jgjk.s23')"></el-table-column>
          <el-table-column prop="FinalPrice" :label="$t('jgjk.s24')"></el-table-column>
          <el-table-column prop="MonitorPrice" :label="$t('jgjk.s25')"></el-table-column>
          <el-table-column prop="MarginPrice" :label="$t('jgjk.s26')"></el-table-column>
          <el-table-column prop="MarginPercenta" :label="$t('jgjk.s27')"></el-table-column>
          <el-table-column :label="$t('jgjk.s37')" v-if="projectscreenshot">
            <template slot-scope="scope">
              <a :href="scope.row.img" target="_blank"><i class="el-icon-picture-outline"></i></a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      tabledata: [],
      tableloading: true,
      projectscreenshot: false,
    }
  },
  mounted(){
    this.initUrlDetail()
  },
  methods: {

    /**
     * 低价监测行颜色
     */
    tableRowClassName({row, rowIndex}) {
      if (row.MarginPrice < 0) {
        return 'warning-row'
      }
      return '';
    },

    /**
     * 初始化当前监测链接
     */
    initUrlDetail: function(){
      console.log('initUrlDetail')
      let that = this
      let url = that.API_URL + '/v3/price/statistics/dashboard'
      let MonitorId = {
        assetid: this.$route.params.Mid
      }
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""},
        data: MonitorId,
        success: function(rex) {
          console.log('----initUrlDetail', rex)

          // if(JSON.parse(localStorage.getItem("projectscreenshot")).val === true && rex.info[0].Channel != '拼多多'){
          //   that.projectscreenshot = true
          // }

          that.tableloading = false
          /**
           * 近24小时
           */
          let dashdata1 = rex.result[0]
          let line24hsx = []
          let line24hsy1 = []
          let line24hsy2 = []
          for(let i=0; i<dashdata1.length; i++){
            line24hsx.push(that.$moment(dashdata1[i].CurrentDate).utc().local().format('hh:mm'))
            line24hsy1.push(dashdata1[i].FinalPrice)
            line24hsy2.push(dashdata1[i].MonitorPrice)
          }
          line24hsx.reverse()
          line24hsy1.reverse()
          line24hsy2.reverse()
          that.linechartdata24hs = {
            xAxis_data : line24hsx,
            series_data : [{
              color: '#F57676',
              name: that.$t('jgjk.s32'),
              type: 'line',
              data: line24hsy2,
            },{
              color: '#7290F2',
              name: that.$t('jgjk.s35'),
              type: 'line',
              data: line24hsy1,
            }]
          }

          /**
           * 价格趋势
           */
          let dashdata2 = rex.result[1]
          let linetrendsx = []
          let linetrendy1 = []
          let linetrendy2 = []
          for(let i=0; i<dashdata2.length; i++){
            linetrendsx.push(that.$moment(dashdata2[i].CurrentDate).utc().local().format('MM/DD'))
            linetrendy1.push(dashdata2[i].FinalPrice)
            linetrendy2.push(dashdata2[i].MonitorPrice)
            if(i===dashdata2.length-1){
              that.linechartdatatrendtitle = that.$moment(dashdata2[0].CurrentDate).utc().local().format('YYYY/MM/DD') + ' - ' + that.$moment(dashdata2[i].CurrentDate).utc().local().format('YYYY/MM/DD')
            }
          }
          that.linechartdatatrend = {
            xAxis_data : linetrendsx,
            series_data : [{
              color: '#F57676',
              name: that.$t('jgjk.s32'),
              type: 'line',
              data: linetrendy2,
            },{
              color: '#7290F2',
              name: that.$t('jgjk.s35'),
              type: 'line',
              data: linetrendy1,
            }]
          }
          
          /**
           * 表格数据
           */
          let tables = []
          let tablerex = rex.result[2]
          let chksnapshot = 0
          for(let i=0; i<tablerex.length; i++){
            let item= {}
            item.InsertDate = that.$moment(tablerex[i].InsertDate).utc().local().format('YYYY/MM/DD HH:mm:ss')
            item.Seller = rex.info[0].Seller
            item.CurrentPrice = tablerex[i].CurrentPrice
            item.FinalPrice = tablerex[i].FinalPrice
            item.MonitorPrice = tablerex[i].MonitorPrice
            item.MarginPrice = tablerex[i].MarginPrice
            item.MarginPercenta = (tablerex[i].MarginPercent*100).toFixed(2) + '%'
            if(tablerex[i].snapshot!=undefined){
              chksnapshot = chksnapshot + 1
              //item.img = 'http://bpsimg.simplybrand.com' + tablerex[i].snapshot
              item.img = tablerex[i].snapshot
            }else{
              item.img = 'http://bpsimg.simplybrand.com/e'
              chksnapshot = chksnapshot + 0
            }
            tables.push(item)
          }
          if(chksnapshot > 0 && rex.info[0].Channel != '拼多多'){
            that.projectscreenshot = true
          }
          that.tabledata = tables

        },
        error: function(response) {
          console.log('----initUrlDetail', response)
        }
      });      
    },
  }
}
</script>